<template>
    <div>
        <Modal
            v-model="positionCodeShow"
            title="选择职位编码"
            width="50%"
            :closable="false"
            :mask-closable="false"
           >
            <div>
                <!-- <Form inline label-position="left">
                <FormItem label="问题" :label-width="100" >
                <Input  v-model="searchItem.question" ></Input>
                </FormItem>
                </Form>  -->
                <Table border ref="table"  :loading="loading"  :columns="columns" :data="tableData"  size="small"> 
                    <template slot-scope="{ row }"  slot="select">
                        <Button type="text" @click="posCodeSave(row)" size="small">选择</Button>     
                    </template>
                </Table>
                <Page :total="totalNum" :page-size="pageInfo.pageSize" @on-change="pageChange" style="margin-top:20px"/>
            </div>
            <div slot="footer">
                <!-- <Button type="text" @click="posCodeSave()">确认</Button>            -->
                <Button type="text" @click="poscancle()">取消</Button>        
            </div>
        </Modal>
    </div>
</template>


<script>
import axios from 'axios'
export default {
    props:["positionCodeShow"],
    data(){
        return{
            searchItem:{},
            loading:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
                itemCount: 4, //总条数
            },
            tableData:[],
            columns:[
                {
                    title:"选择",
                    slot: 'select',
                    align: "center",
                    width:150
                },
                {
                    title : "职位编码",
                    key: "positioncode",
                    align: "center",
                    minWidth:220
                },
                {
                    title : "职位名称",
                    key: "positionChName",
                    align: "center",
                    minWidth:220
                },

            ],
        }
    },
    created(){
        this.getTableData()
    },
    methods:{
        getTableData(){
            this.loading=true
            let obj = {
                pageNo:this.pageInfo.pageNo,
                pageSize:this.pageInfo.pageSize
            }
            axios.post("/OrgPosition/selectPositionSelectionInfo", obj).then((res) => {
                this.loading=false
                if(res){
                    
                  this.tableData=res.data
                  this.tableData.splice(0,1)
                   
                }
            })
        },
        handleConfirm(){},
        posCodeSave(row){
            this.$emit('posCodeItem',row)
        },
        poscancle(){
            this.$emit('posCodecancle')
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getTableData()
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/MyQuery/components/PositionCode.vue